import { styled } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'

const CustomLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
})

export default CustomLink
